import React, { useState } from 'react'
import styled from '@emotion/styled'
import { Form, Input, Upload, Button, Icon, Checkbox } from 'antd'
import { FLOWS, FLOW_NAME_FIELD, FLOW_ACTIONS, FLOW_KEYS, SUCCESS, FLOW_SCAN_KEYS, SCAN_PARAMETERS_FLAG_FIELD } from 'views/ScanSettings/NewScan/constants'
import DynamicForm from 'views/ScanSettings/NewScan/components/DynamicForm'
import { remoteValidation, extractResponse } from '../steps/validate';
import { TooltipLabel } from 'components/TooltipLabel';

const StyledFormRow = styled.div({
	display: 'grid',
	gridTemplateColumns: '2fr 1fr',
	gridGap: 20
})

const enableParameterTooltip = "Check this option to replace current URL used during the flow recording with $BASE_ADDRESS parameter which will be used for parameterized scans.";


const Flows = ({ form, flows, prefix, multiple, setValidationError, simpleMode }) => {
	const [file, setFile] = useState(null)
	const { getFieldDecorator, setFields } = form
	let flowsField = prefix ? `${prefix}${FLOWS}` : FLOWS
	let nameField = prefix ? `${prefix}${FLOW_NAME_FIELD}` : FLOW_NAME_FIELD
	let actionsField = prefix ? `${prefix}${FLOW_ACTIONS}` : FLOW_ACTIONS
	const props = {
		beforeUpload: file => {
			const reader = new FileReader()
			reader.onload = () => {
				try {
					let jsonFile = JSON.parse(reader.result)
					setFields({
						[actionsField]: {
							value: jsonFile
						}
					})
					setFile(jsonFile)
				} catch (e) {
					setFields({
						[actionsField]: {
							errors: [new Error('Invalid JSON File')]
						}
					})
				}
			}
			reader.onabort = () => console.log('file reading was aborted')
			reader.onerror = () => console.log('file reading has failed')
			reader.readAsText(file)
			return false
		},
		onRemove: () => {
			setFile(null);
		},
		file
	}

	const onRemoteValidation = async (values) => {		
		try{
			let failureResponse = { origin: 'server', errors: [] }
			if (values) 
			{
				let isTypeFlow = true;
				let keys = simpleMode ? FLOW_SCAN_KEYS : FLOW_KEYS;
				let response = await remoteValidation(values, keys, '/global/flows/validate', failureResponse, null, null, isTypeFlow)
				response = extractResponse(response)
				failureResponse = response && !!response.length ? response : failureResponse
			}
			return !!failureResponse.errors.length ? failureResponse : SUCCESS;
		}
		catch(err){
			setValidationError(Array.isArray(err) ? err : [err.message]);
		}
	}

	return (
		<DynamicForm
			remoteValidation={async (values) => await onRemoteValidation(values)}
			form={form}
			dataList={flows}
			dataType={flowsField}
			dataTypeText="Flow"
			formFields={[nameField, actionsField, SCAN_PARAMETERS_FLAG_FIELD]}
			nameProp={nameField}
			multiple={false}
			setValidationError={setValidationError}
			resetFlowUploadFile={() => setFile(null)}
		>
			<StyledFormRow>
				<Form.Item label="NAME">
					{getFieldDecorator(nameField, {
						validateTrigger: ['onChange', 'onBlur'],
						rules: [
							{
								required: true,
								whitespace: true,
								message: 'Name is required.'
							}
						]
					})(<Input placeholder="Name" />)}
				</Form.Item>
				<Form.Item label="ACTION">
					{getFieldDecorator(actionsField, {
						validateTrigger: ['onChange', 'onBlur'],
						rules: [
							{
								required: true,
								message: 'Action is Required.'
							}
						]
					})(
						<Upload {...props}>
							<Button disabled={file !== null} size="large">
								<Icon type="upload" /> Select Action File
							</Button>
						</Upload>
					)}
				</Form.Item>
				{!simpleMode && <Form.Item name="parameters">
					{getFieldDecorator(SCAN_PARAMETERS_FLAG_FIELD, {
						initialValue: false,
						valuePropName: 'checked'
					})( 
					<Checkbox id="enableParameters">
						<TooltipLabel htmlFor="enableParameters" value="ENABLE PARAMETERS " 
						tooltip={{text: enableParameterTooltip}} 
						/>  
					</Checkbox>
					)}
				</Form.Item>}
			</StyledFormRow>
		</DynamicForm>
	)
}
export default Flows
